"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _fa = _interopRequireDefault(require("../util/fa"));
var _immutableSetter = require("immutable-setter");
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["files", "children", "multiple", "fileSizeTotalLimit", "disabled"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function humanFileSize(bytes) {
  // copied and modified from: https://stackoverflow.com/a/14919494/2761986

  var thresh = 1024;
  if (Math.abs(bytes) < thresh) {
    return bytes + ' B';
  }
  var units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var u = -1;
  do {
    bytes /= thresh;
    ++u;
  } while (Math.abs(bytes) >= thresh && u < units.length - 1);
  return bytes.toFixed(1) + ' ' + units[u];
}
var FileInput = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function FileInput(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, FileInput);
    _this = _callSuper(this, FileInput, [props]);
    _this.handleSelectFile = _this.handleSelectFile.bind(_this);
    _this.triggerOnChange = _this.triggerOnChange.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(FileInput, _React$Component);
  return (0, _createClass2["default"])(FileInput, [{
    key: "triggerOnChange",
    value: function triggerOnChange(files) {
      var onChange = this.props.onChange;
      if (onChange) {
        onChange(files);
      }
    }
  }, {
    key: "handleSelectFile",
    value: function handleSelectFile(event) {
      this.triggerOnChange(this.props.files.concat(event.target.files[0]));
      try {
        this.refs.file_input.value = '';
        if (this.refs.file_input.value) {
          this.refs.file_input.type = "text";
          this.refs.file_input.type = "file";
        }
      } catch (e) {}
    }
  }, {
    key: "removeFile",
    value: function removeFile(index, e) {
      e.preventDefault();
      var files = (0, _immutableSetter.deleteIn)(this.props.files, [parseInt(index)]);
      this.triggerOnChange(files);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        files = _this$props.files,
        children = _this$props.children,
        multiple = _this$props.multiple,
        fileSizeTotalLimit = _this$props.fileSizeTotalLimit,
        disabled = _this$props.disabled,
        rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      files = _.filter(files, function (f) {
        return f !== undefined && f !== null;
      });
      var filenames = [];
      var total_file_size = 0;
      for (var index in files) {
        var file = files[index];
        filenames.push( /*#__PURE__*/_react["default"].createElement("div", {
          key: index
        }, file.name, " (", humanFileSize(file.size), ")\xA0", /*#__PURE__*/_react["default"].createElement("a", {
          href: "#",
          className: "text-danger",
          onClick: this.removeFile.bind(this, index),
          style: {
            position: "absolute"
          }
        }, /*#__PURE__*/_react["default"].createElement(_fa["default"], {
          icon: "times"
        }))));
        total_file_size += file.size;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "file-upload-input"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])("btn btn-outline-primary mb-1", {
          disabled: disabled
        })
      }, /*#__PURE__*/_react["default"].createElement("span", null, children), /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
        type: "file",
        multiple: multiple,
        ref: "file_input",
        disabled: disabled
      }, rest, {
        onChange: this.handleSelectFile
      }))), /*#__PURE__*/_react["default"].createElement("label", null, filenames, fileSizeTotalLimit !== null && total_file_size > fileSizeTotalLimit && /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-danger"
      }, /*#__PURE__*/_react["default"].createElement(_fa["default"], {
        icon: "exclamation-triangle"
      }), " Total file size cannot exceed ", humanFileSize(fileSizeTotalLimit))));
    }
  }]);
}(_react["default"].Component);
FileInput.propTypes = {
  multiple: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  files: _propTypes["default"].array,
  fileSizeTotalLimit: _propTypes["default"].number,
  disabled: _propTypes["default"].bool
};
FileInput.defaultProps = {
  multiple: false,
  files: [],
  fileSizeTotalLimit: null,
  disabled: false
};